import { useSearchParams } from "react-router-dom";
import CustomAuthForm from "@/components/auth/CustomAuthForm";
import { useReferralValidation } from "@/hooks/useReferralValidation";
import { ReportPreviewCard } from "@/components/auth/ReportPreviewCard";
import { hasUnauthenticatedEntityData } from "@/utils/localStorageEntityData";
import { AuthLayout } from "@/components/auth/AuthLayout";
import type { AuthMode } from "@/components/auth/CustomAuthForm";

const AuthPage = () => {
  useReferralValidation();

  const [searchParams, setSearchParams] = useSearchParams();
  const queryMode = searchParams.get("mode");
  const mode: AuthMode =
    queryMode === "signin" || queryMode === "forgot-password"
      ? queryMode
      : "signup";
  const setMode = (newMode: AuthMode) => {
    const next = new URLSearchParams(searchParams);
    next.set("mode", newMode);
    setSearchParams(next, { replace: true });
  };

  const headingText =
    mode === "signup"
      ? "Creează-ți contul gratuit"
      : mode === "signin"
        ? "Bine ați revenit!"
        : "Resetare parolă";

  return (
    <AuthLayout
      heading={headingText}
      leftContent={<CustomAuthForm mode={mode} onModeChange={setMode} />}
      rightContent={
        <>
          <ReportPreviewCard />
          {hasUnauthenticatedEntityData() && (
            <p className="font-mono text-xs text-ds-text-300 auth-unauthenticated-note">
              Mai ai 2 pași de completat pentru raportul final: alegerea
              serviciilor prestate și adăugarea datelor tehnice.
            </p>
          )}
        </>
      }
    />
  );
};

export default AuthPage;
